<div class="ui-g loyalty-cluster" *ngIf="render.datatable">
  <div class="ui-g-12">

    <app-kontable title = "{{ 'card_batch.card_batch_title' | translate }}"
                  [columns] = "[
                    'id',
                    'storeDescription',
                    { field: 'channelDescription', title: 'card_batch.channel_id', filterType: customFilter, filterTemplate: channelFilter },
                    { field: 'flg_dpl', title: 'card_batch.flg_dpl', bodyTemplate: deployTemplate, filterType: customFilter, filterTemplate: deployFilter },
                    'cardDefPrefix',
                    'formatted_num_min',
                    'formatted_num_max',
                    'clusterHeadDescription',
                    { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: stateFilter}
                  ]"
                  [titles] = "['common.id', 'card_batch.store_id', 'card_batch.prefix', 'card_batch.num_min', 'card_batch.num_max','cluster.clusterHead']"
                  [paginationType]="serverPagination"
                  [showInfoButton]="false"
                  [showGlobalFilter]="false"
                  [showDetailsButton]="false"
                  [showAddButton]="true"
                  [service]="cardBatchService"
                  [(fireNewDataAvailable)]="newDataAvailable"
                  (onAdd)="add()"
                  (onRecover)="recover($event)"
                  [showEditButton]="false"
                  [showDeleteButton]="false"
                  [showRecoverButton]="false"
                  [additionalRowCommands]="customButton"
                  #table data-testid="table" >

      <ng-template #customButton data-testid="customButton" let-row>
        <p-button label="" icon="fa fas fa-pencil" styleClass="ui-button-info" *ngIf="cardDefPermissions && cardDefPermissions.allowsPUT && row.flg_state === '0' && row.flg_dpl === '0'"
                  (onClick)="edit(row)" pTooltip="{{ 'common.edit' | translate }}"></p-button>
        <p-button label="" icon="fa fas fa-trash" styleClass="ui-button-info" *ngIf="cardDefPermissions && cardDefPermissions.allowsDELETE && row.flg_state === '0' && row.flg_dpl === '0'"
                  (onClick)="remove(row)" pTooltip="{{ 'common.delete' | translate }}"></p-button>
        <p-button label="" icon="fa fas fa-rocket" styleClass="ui-button-info" *ngIf="row.flg_dpl === '0' || row.flg_dpl === '9'"
                  (onClick)="readyDeployBatch(row.id)" pTooltip="{{ 'card_batch.deploy' | translate }}"></p-button>
        <p-button label="" icon="fa fas fa-fast-backward" styleClass="ui-button-info" *ngIf="row.flg_dpl === '1'"
                  (onClick)="resetDeployBatch(row.id)" pTooltip="{{ 'Reset' | translate }}"></p-button>
        <p-button label="" pTooltip="{{ 'common.undo' | translate }}" icon="fa fas fa-undo" styleClass="ui-button-info" *ngIf="cardDefPermissions && cardDefPermissions.allowsDELETE && row.flg_state === '1' && row.flg_dpl === '0'"
                  (onClick)="recover(row)"></p-button>
      </ng-template>

      <ng-template #channelFilter data-testid="channelFilter" let-col>
        <p-dropdown [options]="listChannel" [style]="{'width':'100%'}"  (onChange)="table.updateTableFilter('channel_id', $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #deployFilter data-testid="deployFilter" let-col>
        <p-dropdown [options]="listDeploy" [style]="{'width':'100%'}"  (onChange)="table.updateTableFilter('flg_dpl', $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #stateTemplate data-testid="stateTemplate" let-row class="deleted-row">
        <span *ngIf="row.flg_state == '1'" class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span>
     </ng-template>

      <ng-template #stateFilter data-testid="stateFilter" let-col>
          <p-dropdown [options]="listStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #deployTemplate data-testid="deployTemplate" let-row>
        <span *ngIf="row.flg_dpl === '0'">{{ 'card_batch.anag' | translate }}</span>
        <span *ngIf="row.flg_dpl === '1'">{{ 'card_batch.creating' | translate }}</span>
        <span *ngIf="row.flg_dpl === '2'">{{ 'card_batch.deploying' | translate }}</span>
        <span *ngIf="row.flg_dpl === '3'">{{ 'card_batch.deployed' | translate }}</span>
        <span *ngIf="row.flg_dpl === '4'">{{ 'card_batch.ext_wait' | translate }}</span>
        <span *ngIf="row.flg_dpl === '9'">{{ 'card_batch.ext_fail' | translate }}</span>
      </ng-template>

    </app-kontable>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card-batch/loyalty-card-batch.component.html